// ResetPassword — /reset-password?token=… from the "Forgot password?" email. TMCHub checks the
// token and sets the password; on success the backend signs the person straight in.

import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthApi } from "../hooks/useApi.js";
import { useAuth } from "../auth/AuthProvider.jsx";
import { LoginShell } from "./Login.jsx";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const cyber = typeof document !== "undefined" && document.documentElement.dataset.theme === "cyberpunk";

  async function submit(e) {
    e.preventDefault();
    setError("");
    if (password.length < 6) { setError("Password must be at least 6 characters long."); return; }
    if (password !== confirm) { setError("The two passwords don't match."); return; }
    setBusy(true);
    try {
      const res = await AuthApi.reset(token, password);
      if (res?.signedIn) {
        await refresh();
        try { sessionStorage.setItem("tmc.boot", "1"); } catch { /* non-fatal */ }
        navigate("/", { replace: true });
      } else {
        navigate("/login", { replace: true, state: { notice: "Password changed. Sign in with your new password." } });
      }
    } catch (err) {
      setError(err.body?.error || "Could not reset your password. Try again shortly.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <LoginShell onSubmit={submit} cyber={cyber}>
      <p className="login__tagline">Choose a new password</p>
      {!token ? (
        <div className="field__err">⚠ This reset link is incomplete. Open the link from the email again.</div>
      ) : (
        <>
          <div className="field">
            <label className="field__label">New password</label>
            <input className="input" type="password" autoComplete="new-password" value={password} autoFocus
                   onChange={(e) => setPassword(e.target.value)} required minLength={6} />
          </div>
          <div className="field">
            <label className="field__label">Confirm new password</label>
            <input className="input" type="password" autoComplete="new-password" value={confirm}
                   onChange={(e) => setConfirm(e.target.value)} required minLength={6} />
          </div>
          {error && <div className="field__err">⚠ {error}</div>}
          <button className="btn btn--primary btn--block" type="submit" disabled={busy}>
            {busy ? <span className="btn__spin" /> : "Set password & sign in"}
          </button>
        </>
      )}
      <Link className="login__link" to="/login">← Back to sign in</Link>
    </LoginShell>
  );
}
